import Vue from 'vue';
import config from 'config';

const productResultInfos = Vue.component('fl-products-info', {
    template: `
    <div class="fl-position-relative fl-as-result-info">
    <h3 class="fl-background fl-text-center fl-as-result-info-text"
        v-html="this.originalQuery === '' ? emptyQueryText : usedQueryText"></h3>
    <p v-if="showSearchInsteadText" class="fl-as-original-url" @click="selectValue(originalQuery)"
       v-html="searchInsteadText">
    </p>
    </div>
  `,
    props: {
        suggestionQuery: String,
        totalResults: Number,
        originalQuery: String,
    },
    inject: ['config', 'HandleInteractionService', 'requestService', 'utils'],
    computed: {
        escapedOriginalQuery(): string {
            return this.utils.escapeUserProvidedText(this.originalQuery);
        },
        emptyQueryText(): string {
            return this.config.assistedSuggest.text.usedEmptyQueryLabel.replace(
                '%count%',
                `<span class="fl-empty-query-text-count">${this.$props.totalResults}</span>`
            );
        },
        usedQueryText(): string {
            const mostRecentResponseWithProducts = this.requestService.getMostRecentResponseWithProducts();
            if (
                config.assistedSuggest.config.showResultsIfLastSearchHadNoResults &&
                this.$props.totalResults === 0 &&
                mostRecentResponseWithProducts
            ) {
                const escapedEffectiveProductSuggestionQuery = this.utils.escapeUserProvidedText(
                    mostRecentResponseWithProducts.effectiveProductSuggestionQuery
                );

                return this.config.assistedSuggest.text.sdymMostRecentQueryLabel
                    .replace('%query%', `<span class="fl-used-query-text-query">${this.escapedOriginalQuery}</span>`)
                    .replace(
                        '%mostRecentQuery%',
                        `<span class="fl-recent-query-text-query">${escapedEffectiveProductSuggestionQuery}</span>`
                    )
                    .replace(
                        '%mostRecentCount%',
                        `<span class="fl-recent-query-text-count">${mostRecentResponseWithProducts.totalResults}</span>`
                    );
            } else {
                const queryText = this.utils.escapeUserProvidedText(
                    this.showOriginalQueryInsteadOfSuggested ? this.$props.originalQuery : this.$props.suggestionQuery
                );

                return this.config.assistedSuggest.text.effectiveProductSuggestionQueryLabel
                    .replace('%query%', `<span class="fl-used-query-text-query">${queryText}</span>`)
                    .replace('%count%', `<span class="fl-used-query-text-count">${this.$props.totalResults}</span>`);
            }
        },
        searchInsteadText(): string {
            return this.config.assistedSuggest.text.sdymLabel.replace(
                '%query%',
                `<span class="fl-sdym-text-query">${this.escapedOriginalQuery}</span>`
            );
        },
        showSearchInsteadText(): boolean {
            return this.suggestionQuery.toLowerCase() !== this.originalQuery.toLowerCase() && !this.showOriginalQueryInsteadOfSuggested;
        },
        showOriginalQueryInsteadOfSuggested(): boolean {
            return this.suggestionQuery === '' && this.totalResults > 0;
        },
    },
    methods: {
        selectValue(query: string): void {
            this.HandleInteractionService.byQuery(query).submit();
        },
    },
});

export default productResultInfos;
